








import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
@Component
export default class ParentPageView extends AbpBase {
  get excludeCacheNavList(){
    return this.$store.state.app.excludeKeepAliveList;
  }
}
